var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPepiconsPopPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pepicons-pop:person"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24713 6C6.24713 7.06087 6.66856 8.07828 7.4187 8.82843C8.16885 9.57857 9.18627 10 10.2471 10C11.308 10 12.3254 9.57857 13.0756 8.82843C13.8257 8.07828 14.2471 7.06087 14.2471 6C14.2471 4.93913 13.8257 3.92172 13.0756 3.17157C12.3254 2.42143 11.308 2 10.2471 2C9.18627 2 8.16885 2.42143 7.4187 3.17157C6.66856 3.92172 6.24713 4.93913 6.24713 6ZM12.2471 6C12.2471 6.53043 12.0364 7.03914 11.6613 7.41421C11.2863 7.78929 10.7776 8 10.2471 8C9.7167 8 9.20799 7.78929 8.83292 7.41421C8.45785 7.03914 8.24713 6.53043 8.24713 6C8.24713 5.46957 8.45785 4.96086 8.83292 4.58579C9.20799 4.21071 9.7167 4 10.2471 4C10.7776 4 11.2863 4.21071 11.6613 4.58579C12.0364 4.96086 12.2471 5.46957 12.2471 6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.2471 18C17.2471 18.2652 17.1418 18.5196 16.9542 18.7071C16.7667 18.8946 16.5123 19 16.2471 19C15.9819 19 15.7276 18.8946 15.54 18.7071C15.3525 18.5196 15.2471 18.2652 15.2471 18V15.5C15.2471 13.006 13.0411 11 10.2631 11C7.47713 11 5.24713 13.013 5.24713 15.5L5.24913 18C5.24913 18.2652 5.14377 18.5196 4.95624 18.7071C4.7687 18.8946 4.51435 19 4.24913 19C3.98391 19 3.72956 18.8946 3.54202 18.7071C3.35449 18.5196 3.24913 18.2652 3.24913 18L3.24713 15.5C3.24713 11.86 6.41613 9 10.2631 9C14.1071 9 17.2471 11.857 17.2471 15.5V18Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepiconsPopPerson);
export default __webpack_public_path__ + "static/media/pepicons-pop_person.670b5b5efa6ded6c01a4d90bb8efd90b.svg";
export { ForwardRef as ReactComponent };